const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlotBookingConfirmation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-4"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185.85,
    cy: 89.67,
    r: 23.55,
    transform: "translate(-15.63 45.1) rotate(-13.28)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185.85,
    cy: 89.67,
    r: 20.03,
    transform: "translate(-11.96 30.93) rotate(-9.22)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "186.79 75.93 186.79 89.93 196.07 84.68",
    style: {
      fill: "#f0f0f0",
      stroke: "#e0e0e0",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.78,345.28c0-.4,1.35-39.68,7.74-45.89,6.21-6,13.34-.22,13.64,0l.64-.77c-.08-.07-8.13-6.64-15,0-6.68,6.5-8,44.94-8,46.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.24,353c0-.47,4.36-47.16-12.69-66.72l-.75.65c16.77,19.25,12.49,65.51,12.44,66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.87,348.06l1-.07c0-.52-3.33-53.07,9.17-64.57l-.67-.74C70.5,294.51,73.72,345.88,73.87,348.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.24,348h1c0-1.44-.41-35.49-10.08-41a6.85,6.85,0,0,0-6.26-.61c-5.85,2.42-8.75,12.82-8.87,13.27l1,.26c0-.1,2.89-10.38,8.28-12.61a5.91,5.91,0,0,1,5.38.56C71.84,313.11,72.24,347.68,72.24,348Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,348.06l1-.06c0-.27-1.46-26.9,5.73-36.29,1.74-2.27,3.63-3.36,5.63-3.22,4.71.33,8.66,7.22,8.7,7.29l.87-.49c-.17-.3-4.25-7.43-9.5-7.79-2.34-.17-4.53,1-6.49,3.6C74.52,320.78,75.94,347,76,348.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.43,351.68c.19-2.58,4.7-63.4-3.23-74.12l-.8.59c7.71,10.42,3.08,72.82,3,73.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.74,312.54s4.76,1.75,3.34,5.89-16.44,10.95-16.44,10.95-6.3-5.77-.51-15.16S54.61,309.58,54.74,312.54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.41,304.67s-5.06-.22-5.35,4.15,11,16.43,11,16.43,8-2.9,6.31-13.79S76.67,302,75.41,304.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.69,283.78s-3.37-.36-3.1-2.41,13.12-7.35,20.7,1.2c0,0-4.85,8.34-11.87,8.45S79.69,283.78,79.69,283.78Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4,278.79s3.06,1.48,3.92-.41-7.25-13.17-18.21-9.92c0,0-.29,9.64,5.61,13.45S73.4,278.79,73.4,278.79Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.38,310.88s-2.33-1.88.19-2.8,14.84-.66,15,11.56c0,0-14.36,2.39-16.14-2.27S89.38,310.88,89.38,310.88Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.09,283.48s2.33-1.88-.18-2.8-14.85-.66-15,11.56c0,0,14.37,2.39,16.14-2.27S60.09,283.48,60.09,283.48Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.69,293.32s.2-2.29-1.65-1.39-8.27,7.83-1.61,14.41c0,0,9-6.64,7.36-10.1S67.69,293.32,67.69,293.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.47,296.58s-1.4-1.83.64-2.05,11.18,2.21,9,11.33c0,0-11.13-.84-11.61-4.62S91.47,296.58,91.47,296.58Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.85 381.89 92.05 381.89 96.17 340.07 49.73 340.07 53.85 381.89",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.69,
    y: 335.46,
    width: 50.52,
    height: 9.23,
    transform: "translate(145.91 680.14) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.68,
    y: 144.28,
    width: 90.65,
    height: 4.66,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.85,
    y: 127.11,
    width: 3.99,
    height: 17.17,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.16,
    y: 127.11,
    width: 3.99,
    height: 17.17,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.57,
    y: 126.9,
    width: 3.99,
    height: 17.17,
    transform: "translate(-21.63 18.03) rotate(-9.78)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.8,
    y: 129.37,
    width: 3.99,
    height: 14.91,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.98,
    y: 129.37,
    width: 3.99,
    height: 14.91,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.15,
    y: 129.37,
    width: 3.99,
    height: 14.91,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.07,
    y: 129.12,
    width: 3.99,
    height: 14.91,
    transform: "translate(-27.76 20.18) rotate(-12.53)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.25,
    y: 126.26,
    width: 2,
    height: 18.02,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 126.26,
    width: 2,
    height: 18.02,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.17,
    y: 130.69,
    width: 19.46,
    height: 13.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.68,
    y: 179.05,
    width: 90.65,
    height: 4.66,
    transform: "translate(182.01 362.75) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.16,
    y: 161.88,
    width: 3.99,
    height: 17.17,
    transform: "translate(260.32 340.92) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.85,
    y: 161.88,
    width: 3.99,
    height: 17.17,
    transform: "translate(221.7 340.92) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.44,
    y: 161.66,
    width: 3.99,
    height: 17.17,
    transform: "translate(144.7 352.87) rotate(-170.22)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.21,
    y: 164.14,
    width: 3.99,
    height: 14.91,
    transform: "translate(250.42 343.19) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.03,
    y: 164.14,
    width: 3.99,
    height: 14.91,
    transform: "translate(232.06 343.19) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.87,
    y: 164.14,
    width: 3.99,
    height: 14.91,
    transform: "translate(185.72 343.19) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.94,
    y: 163.89,
    width: 3.99,
    height: 14.91,
    transform: "translate(168.24 361.14) rotate(-167.47)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.76,
    y: 161.03,
    width: 2,
    height: 18.02,
    transform: "translate(241.52 340.07) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.01,
    y: 161.03,
    width: 2,
    height: 18.02,
    transform: "translate(194.01 340.07) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.38,
    y: 165.46,
    width: 19.46,
    height: 13.43,
    transform: "translate(128.22 344.35) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.97,
    y: 111.73,
    width: 164.45,
    height: 145.92,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.09,
    y: 115.73,
    width: 156,
    height: 138,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.7 115.73 269.09 253.43 269.09 188.73 288.42 115.73 305.7 115.73",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.67 115.73 281.74 253.73 275.84 253.73 312.78 115.73 318.67 115.73",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.09 202.81 425.09 224.86 417.62 253.73 411.73 253.73 425.09 202.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.88,
    y: 113.25,
    width: 2.63,
    height: 143.56,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.8,
    y: 113.25,
    width: 2.63,
    height: 143.56,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.76,357.1a3,3,0,0,0-2.38-4.27,6.38,6.38,0,0,0-2-7,1.5,1.5,0,0,0-.88-.39,1.7,1.7,0,0,0-.94.41l-5.58,4a3.37,3.37,0,0,0-1.1,1.09c-1.14,2.21,3,5,1.28,6.86-.49.52-1.27.63-1.87,1-1.33.83-1.49,2.65-2.11,4.09s-2.77,2.55-3.6,1.22c.61-1.38-1.23-2.56-2.73-2.74s-3.06-.26-3.89-1.66c-2.12,1.85-6.88-3.32-6.77-5.41-1.74.13-2.93,1.77-3.31,3.4a24.41,24.41,0,0,0-.18,5.2c-.06,3.39-1.15,6.7-1.09,10.08.05,2.63,1.07,5.55,3.47,6.61a9.05,9.05,0,0,0,3.74.5l27.43-.17a4.32,4.32,0,0,0,1.93-.32c1.24-.65,1.5-2.28,1.61-3.67q.74-8.94,1.48-17.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.36,328.11H401.8l.35,4.3.25,3.07.65,8,.37,4.59.49,6.11.21,2.62.07.78.25,3.08.34,4.22.21,2.62.22,2.66.25,3.08.19,2.33.21,2.62.09,1.14H445l.09-1.14.21-2.61.19-2.35.25-3.08.22-2.65.21-2.62.34-4.23.25-3.07.06-.78.21-2.62.5-6.11.37-4.58.64-8,.25-3.07.35-4.3Zm2.56,2.82h0l-.82-.82H447Zm-.21,2.61-.08,1-3.81,3.81L438.45,334l3.91-3.91h.92Zm-1.1,13.62L442.82,350l-4.37-4.37,4.37-4.36,3,3Zm-40.5-2.92h0l3-3,4.37,4.36L408.13,350l-2.78-2.79Zm36.3-4.44L437,344.17l-4.37-4.37,4.37-4.37Zm-6.87-9.69h5l-2.5,2.5Zm1.08,15.47L431.26,350l-4.37-4.37,4.37-4.36Zm-14.51,5.78,4.37-4.36,4.36,4.36-4.36,4.37Zm2.95,5.78-4.37,4.37-4.36-4.36,4.37-4.37Zm7.2-4.36,4.36,4.37-4.36,4.36-4.37-4.37Zm-5.78-8.61-4.37-4.37,4.37-4.37,4.36,4.37Zm-1.42,1.41L419.7,350l-4.37-4.37,4.37-4.36Zm-10.15-1.41-4.36-4.37,4.36-4.37,4.37,4.37Zm0,2.83,4.37,4.36-4.37,4.37-4.36-4.37Zm4.37,15.93-4.37,4.36-4.36-4.36,4.36-4.37Zm1.41,1.41,4.37,4.37-4.36,4.37-4.37-4.37Zm1.42-1.41,4.37-4.37,4.36,4.37-4.36,4.36Zm10.15,1.41,4.36,4.37-4.36,4.37-4.37-4.37Zm5.78,5.78,4.37,4.37-2.83,2.83H435.5l-2.83-2.83Zm-4.37-7.19,4.37-4.37,4.37,4.37L437,367.29Zm0-11.57L437,347l4.37,4.36L437,355.73ZM435.62,334l-4.36,4.37L426.89,334l3.91-3.91h.92Zm-10.14-1.41-2.5-2.5h5ZM424.06,334l-4.36,4.37L415.33,334l3.91-3.91h.92Zm-7.65-3.91-2.5,2.5-2.49-2.5Zm-7.82,0L412.5,334l-4.37,4.37-3.8-3.81-.08-1,3.42-3.43Zm-3.74,0-.81.81h0l-.07-.81Zm-.27,7.55,2.14,2.14-1.82,1.82Zm1.19,14.65-.17-2.07h0l1.12,1.12-1,.95Zm.21,2.63,2.15-2.16,4.37,4.37-4.37,4.36-1.76-1.76Zm.65,8.08v-.19l.1.1-.09.09Zm.76,9.31-.55-6.7,1.29-1.29,4.37,4.37-4.37,4.36-.74-.74Zm.4,5-.08-1,.42-.42,1.42,1.42Zm1.76-2.83,4.36-4.37,4.37,4.37-2.83,2.83h-3.08Zm8.73,2.83,1.42-1.42,1.42,1.42Zm5.66,0-2.83-2.83,4.37-4.37,4.36,4.37L427,377.32Zm5.9,0,1.42-1.42,1.42,1.42Zm13.32,0H441.4l1.42-1.42.42.42Zm.41-5-.75.74-4.37-4.36,4.37-4.37,1.29,1.29Zm.77-9.51,0,.2-.09-.09.11-.11Zm.25-3.07-1.77,1.76-4.37-4.36,4.37-4.37,2.16,2.16Zm.6-7.43-1-1,1.13-1.12Zm1.19-14.67-.32,4-1.83-1.83,2.15-2.15Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.08,
    y: 326.33,
    width: 52.8,
    height: 5.57,
    rx: 1.64,
    transform: "translate(850.96 658.22) rotate(-180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.89,
    y: 376.33,
    width: 45.19,
    height: 5.57,
    rx: 1.64,
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-4"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-4",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 140.56,
    y: 130.84,
    width: 91.44,
    height: 117.55,
    rx: 36.32,
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.56,
    y: 130.84,
    width: 91.44,
    height: 117.55,
    rx: 36.32,
    style: {
      fill: "#fff",
      opacity: 0.8,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.01,
    y: 137.56,
    width: 80.99,
    height: 104.11,
    rx: 29.71,
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,167.27V212a29.71,29.71,0,0,1-29.71,29.71H177.72A29.72,29.72,0,0,1,148,212V167.27a29.71,29.71,0,0,1,29.71-29.71h21.57A29.71,29.71,0,0,1,229,167.27Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,173.23v11.13H195.1a9.61,9.61,0,1,1,0-19.21h.17a10.42,10.42,0,0,1,19.32-5.27,12.25,12.25,0,0,1,2.2-.2,11.92,11.92,0,0,1,11.92,11.92,12.36,12.36,0,0,1-.13,1.73Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.34,217.89a5.63,5.63,0,0,1-5.46,5.62H150.35A29.42,29.42,0,0,1,148,212V196.09a10.4,10.4,0,0,1,15.09,3,12.33,12.33,0,0,1,2.2-.21,11.93,11.93,0,0,1,11.92,11.93,12.22,12.22,0,0,1-.12,1.72,5.7,5.7,0,0,1,1.61-.23A5.63,5.63,0,0,1,184.34,217.89Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 281.91,
    y: 82.79,
    width: 153.32,
    height: 275.77,
    rx: 9.75,
    transform: "translate(717.15 441.35) rotate(180)",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.91,
    y: 82.79,
    width: 153.32,
    height: 275.77,
    rx: 9.75,
    transform: "translate(717.15 441.35) rotate(180)",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.41,
    y: 82.79,
    width: 153.32,
    height: 275.77,
    rx: 9.75,
    transform: "translate(704.14 441.35) rotate(180)",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.88,92v256.8a3.23,3.23,0,0,0,3.46,3.45H420.1c1.95,0,2.9-1.2,2.9-3.14V91.72c0-1.68-.73-2.88-2.41-2.88H386.65a2.25,2.25,0,0,0-2.18,1.39l-1.41,3.32a2.26,2.26,0,0,1-2.18,1.36H323.09a2.28,2.28,0,0,1-2.18-1.41l-1.41-3.3a2.23,2.23,0,0,0-2.18-1.36H283.87A2.92,2.92,0,0,0,280.88,92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.26,
    cy: 88.91,
    r: 1.96,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.33,88.91a1.26,1.26,0,1,0,1.25-1.26A1.25,1.25,0,0,0,349.33,88.91Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.41,341.1v4.76H347.9V341.1h7.51m.1-1.73H347.8a1.63,1.63,0,0,0-1.63,1.63v5a1.63,1.63,0,0,0,1.63,1.63h7.71a1.63,1.63,0,0,0,1.63-1.63v-5a1.63,1.63,0,0,0-1.63-1.63Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.62,
    y: 96.56,
    width: 1.77,
    height: 2.35,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.5,
    y: 95.78,
    width: 1.77,
    height: 3.14,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.37,
    y: 94.99,
    width: 1.77,
    height: 3.93,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.25,
    y: 94.21,
    width: 1.77,
    height: 4.71,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.35,
    y: 95.7,
    width: 1.05,
    height: 2.35,
    transform: "translate(593.74 193.76) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.29,
    y: 94.85,
    width: 8.34,
    height: 4.07,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.88,
    y: 106.05,
    width: 142.12,
    height: 227.28,
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.88,
    y: 106.05,
    width: 142.12,
    height: 227.28,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.15,
    cy: 123.85,
    r: 11.94,
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.84,119.56h-17a2.51,2.51,0,0,1-2.51-2.52h0a2.51,2.51,0,0,1,2.51-2.51h17a2.51,2.51,0,0,1,2.51,2.51h0A2.51,2.51,0,0,1,335.84,119.56Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.89,127.1H317.45a1.11,1.11,0,0,1-1.11-1.11h0a1.12,1.12,0,0,1,1.11-1.12h51.44A1.12,1.12,0,0,1,370,126h0A1.11,1.11,0,0,1,368.89,127.1Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.46,133.17h-36a1.12,1.12,0,0,1-1.11-1.12h0a1.11,1.11,0,0,1,1.11-1.11h36a1.11,1.11,0,0,1,1.11,1.11h0A1.11,1.11,0,0,1,353.46,133.17Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.88,
    y: 144,
    width: 142.12,
    height: 120.42,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.07,237.21a4.89,4.89,0,0,1,4.88-4.88,4.94,4.94,0,0,1,1.4.21,10.59,10.59,0,0,1-.11-1.5,10.34,10.34,0,0,1,10.33-10.33,10.05,10.05,0,0,1,1.91.18,9,9,0,0,1,16.74,4.56h.15a8.32,8.32,0,0,1,0,16.64H376.81A4.87,4.87,0,0,1,372.07,237.21Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.47,214.19a3.65,3.65,0,0,1,4.72-3.51,8.47,8.47,0,0,1-.08-1.13,7.76,7.76,0,0,1,7.76-7.76,7.54,7.54,0,0,1,1.43.14,6.78,6.78,0,0,1,12.57,3.42H319a6.25,6.25,0,0,1,0,12.5H296A3.67,3.67,0,0,1,292.47,214.19Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.17,180.46a2,2,0,0,1,2-2,2.12,2.12,0,0,1,.57.08,6,6,0,0,1,0-.61,4.24,4.24,0,0,1,4.24-4.24,4,4,0,0,1,.78.07,3.7,3.7,0,0,1,6.87,1.87h.07a3.42,3.42,0,0,1,0,6.83H356.11A2,2,0,0,1,354.17,180.46Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.24,251.14a2.59,2.59,0,0,1,2.59-2.6,2.67,2.67,0,0,1,.75.11,5.19,5.19,0,0,1-.06-.8,5.49,5.49,0,0,1,5.5-5.49,5.66,5.66,0,0,1,1,.09,4.8,4.8,0,0,1,8.91,2.43H344a4.43,4.43,0,1,1,0,8.86H327.76A2.59,2.59,0,0,1,325.24,251.14Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.18,193.76l-87.78,32.8,2,5.36s16.9,1.74,31-3.55l66.12-24.7c2-.74,6.6-4.14,5.81-6.09-1.16-2.88-8.15-2.13-8.15-2.13S398.86,192,394.18,193.76Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.55,229.66l-13.91-10.07a2.67,2.67,0,0,0-2.49-.33l-1.64.61a.55.55,0,0,0-.25.85L303,232.13l-2.39.9a1,1,0,0,0-.61,1.35h0a1,1,0,0,0,1.35.61l11.06-4.13Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.07,207.7l-49.58-28.43a2.64,2.64,0,0,0-2.26-.19l-3.94,1.47a.86.86,0,0,0-.35,1.37L346.06,216Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.3,223.81l20.12-7.52-1.26,25.53a3.49,3.49,0,0,1-2.26,3.09l-2.33.87a1,1,0,0,1-1.19-.41Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.4,283.12h-17a2.51,2.51,0,0,1-2.51-2.52h0a2.51,2.51,0,0,1,2.51-2.51h17a2.51,2.51,0,0,1,2.52,2.51h0A2.52,2.52,0,0,1,308.4,283.12Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.91,290.66H290a1.11,1.11,0,0,1-1.11-1.11h0a1.12,1.12,0,0,1,1.11-1.12h119.9a1.12,1.12,0,0,1,1.11,1.12h0A1.11,1.11,0,0,1,409.91,290.66Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.48,297.38H290a1.12,1.12,0,0,1-1.11-1.12h0a1.11,1.11,0,0,1,1.11-1.11H394.48a1.12,1.12,0,0,1,1.12,1.11h0A1.12,1.12,0,0,1,394.48,297.38Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299,304.09h-9A1.11,1.11,0,0,1,288.9,303h0a1.12,1.12,0,0,1,1.11-1.12h9A1.12,1.12,0,0,1,300.1,303h0A1.12,1.12,0,0,1,299,304.09Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.15,310.81H290a1.12,1.12,0,0,1-1.11-1.12h0a1.11,1.11,0,0,1,1.11-1.11H403.15a1.11,1.11,0,0,1,1.11,1.11h0A1.12,1.12,0,0,1,403.15,310.81Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.58,317.52H290a1.11,1.11,0,0,1-1.11-1.11h0A1.11,1.11,0,0,1,290,315.3h50.57a1.11,1.11,0,0,1,1.11,1.11h0A1.11,1.11,0,0,1,340.58,317.52Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.94,166.31H332.18a6.6,6.6,0,0,1-6.6-6.6h0a6.61,6.61,0,0,1,6.6-6.6h39.76a6.61,6.61,0,0,1,6.6,6.6h0A6.6,6.6,0,0,1,371.94,166.31Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.84,161.34a1.5,1.5,0,0,1-.16.72,1.55,1.55,0,0,1-.46.53,2.25,2.25,0,0,1-.66.32,3.12,3.12,0,0,1-.82.11H333.6v-6.51h3.48a1.29,1.29,0,0,1,.62.15,1.42,1.42,0,0,1,.46.38,1.62,1.62,0,0,1,.3.53,1.81,1.81,0,0,1,.11.6,1.72,1.72,0,0,1-.24.89,1.42,1.42,0,0,1-.7.62,1.69,1.69,0,0,1,.89.59A1.76,1.76,0,0,1,338.84,161.34Zm-4-3.75v1.64h1.68a.74.74,0,0,0,.55-.22.79.79,0,0,0,.22-.6.89.89,0,0,0-.2-.6.7.7,0,0,0-.51-.22Zm2.7,3.51a.92.92,0,0,0-.06-.33.85.85,0,0,0-.16-.28.88.88,0,0,0-.24-.19.6.6,0,0,0-.3-.07h-1.94v1.71h1.87a.88.88,0,0,0,.33-.06.68.68,0,0,0,.26-.18.83.83,0,0,0,.17-.27A.72.72,0,0,0,337.57,161.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.61,163.06a2.92,2.92,0,0,1-1.3-.28,3.07,3.07,0,0,1-1-.74,3.27,3.27,0,0,1-.64-1.06,3.19,3.19,0,0,1-.23-1.22,3.26,3.26,0,0,1,.24-1.24,3.53,3.53,0,0,1,.67-1.06,3.2,3.2,0,0,1,1-.72,3,3,0,0,1,1.27-.27,2.9,2.9,0,0,1,1.29.28,3.44,3.44,0,0,1,1,.76,3.8,3.8,0,0,1,.64,1.06,3.42,3.42,0,0,1,.23,1.21,3.22,3.22,0,0,1-.24,1.24,3.34,3.34,0,0,1-.66,1,3.2,3.2,0,0,1-1,.72A3,3,0,0,1,342.61,163.06Zm-1.89-3.3a2.51,2.51,0,0,0,.13.82,2.09,2.09,0,0,0,.37.69,1.74,1.74,0,0,0,.59.49,1.91,1.91,0,0,0,1.62,0,2,2,0,0,0,.59-.5,2.24,2.24,0,0,0,.37-.7,2.72,2.72,0,0,0,.12-.8,2.45,2.45,0,0,0-.13-.81,2.16,2.16,0,0,0-.38-.7,1.84,1.84,0,0,0-.59-.48,1.73,1.73,0,0,0-.79-.18,1.8,1.8,0,0,0-.82.19,1.78,1.78,0,0,0-.59.49,2.47,2.47,0,0,0-.37.7A2.71,2.71,0,0,0,340.72,159.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.53,163.06a2.87,2.87,0,0,1-1.29-.28,3.07,3.07,0,0,1-1-.74,3.29,3.29,0,0,1-.65-1.06,3.39,3.39,0,0,1-.23-1.22,3.09,3.09,0,0,1,.25-1.24,3.51,3.51,0,0,1,.66-1.06,3.37,3.37,0,0,1,1-.72,3,3,0,0,1,1.27-.27,2.9,2.9,0,0,1,1.29.28,3.44,3.44,0,0,1,1.86,3,3.22,3.22,0,0,1-.24,1.24,3.34,3.34,0,0,1-.66,1,3.16,3.16,0,0,1-1,.72A3.06,3.06,0,0,1,349.53,163.06Zm-1.88-3.3a2.81,2.81,0,0,0,.12.82,2.11,2.11,0,0,0,.38.69,1.65,1.65,0,0,0,.59.49,1.89,1.89,0,0,0,1.61,0,2,2,0,0,0,.6-.5,2.21,2.21,0,0,0,.36-.7,2.44,2.44,0,0,0,.13-.8,2.75,2.75,0,0,0-.13-.81,2.36,2.36,0,0,0-.38-.7,1.77,1.77,0,0,0-.6-.48,1.67,1.67,0,0,0-.79-.18,1.76,1.76,0,0,0-.81.19,1.93,1.93,0,0,0-.6.49,2.21,2.21,0,0,0-.36.7A2.71,2.71,0,0,0,347.65,159.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.68,163v-6.5H355v3.09l2.73-3.1h1.39l-2.49,2.89,2.64,3.62H357.8l-2-2.82-.83.87v2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.33,161.91V163h-4.52v-6.51h4.43v1.11h-3.17v1.57h2.74v1h-2.74v1.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.32,163v-6.51h2.36a3.57,3.57,0,0,1,1.4.26,2.88,2.88,0,0,1,1,.69,2.84,2.84,0,0,1,.6,1,3.69,3.69,0,0,1,.21,1.25,3.82,3.82,0,0,1-.23,1.35,2.8,2.8,0,0,1-1.66,1.68,3.45,3.45,0,0,1-1.32.24Zm4.29-3.27a2.67,2.67,0,0,0-.13-.86,1.82,1.82,0,0,0-.37-.67,1.68,1.68,0,0,0-.61-.44,2,2,0,0,0-.82-.16h-1.1v4.29h1.1a2,2,0,0,0,.83-.17,1.69,1.69,0,0,0,.6-.45,1.94,1.94,0,0,0,.37-.68A2.67,2.67,0,0,0,369.61,159.75Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99,394.71l28.81-2.83V351.39h11.42v40.48l28.93,2.84a5.62,5.62,0,0,1,5.06,5.59v4.32H93.92V400.3A5.62,5.62,0,0,1,99,394.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,394.71l28.81-2.83V351.39h11.42v40.48l28.93,2.84a5.62,5.62,0,0,1,5.06,5.59v4.32H93.92V400.3A5.62,5.62,0,0,1,99,394.71Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.15,
    cy: 409.99,
    r: 7.47,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.97,
    cy: 409.99,
    r: 7.47,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,324H137a4.13,4.13,0,0,1,4.13,4.13v31.93a0,0,0,0,1,0,0H125.82a0,0,0,0,1,0,0V328.16A4.13,4.13,0,0,1,130,324Z",
    transform: "translate(267 684.12) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,324H137a4.13,4.13,0,0,1,4.13,4.13v31.93a0,0,0,0,1,0,0H125.82a0,0,0,0,1,0,0V328.16A4.13,4.13,0,0,1,130,324Z",
    transform: "translate(267 684.12) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.15,227.5c.17,27.66,3,84.23,22.9,96.53H92.79a5.5,5.5,0,0,1-4.79-2.8c-4.89-8.67-18.34-37.92-16.06-94.25a15.43,15.43,0,0,1,15.43-14.79h22.34A15.43,15.43,0,0,1,125.15,227.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.15,227.5c.17,27.66,3,84.23,22.9,96.53H95.72s-20.56-28.44-17.78-97a15.43,15.43,0,0,1,15.43-14.79h22.34A15.43,15.43,0,0,1,131.15,227.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.15,227.5c.17,27.66,3,84.23,22.9,96.53H95.72s-20.56-28.44-17.78-97a15.43,15.43,0,0,1,15.43-14.79h22.34A15.43,15.43,0,0,1,131.15,227.5Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,316.48H168a5,5,0,0,1,5,5v6.69a0,0,0,0,1,0,0H96a0,0,0,0,1,0,0v-6.69A5,5,0,0,1,101,316.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.84,
    y: 322.32,
    width: 83.33,
    height: 5.84,
    rx: 2.01,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.84,
    y: 322.32,
    width: 83.33,
    height: 5.84,
    rx: 2.01,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.89 417.45 207.01 417.45 218.02 264.21 209.89 264.21 200.89 417.45",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.88 417.45 207.01 417.45 217.48 271.82 218.02 264.45 209.89 264.45 209.45 271.82 200.88 417.45",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.45 271.45 217.48 271.45 218.02 264.45 209.89 264.45 209.45 271.45",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.66,377.82l-6.94-.67s-8.15-22.23-16.28-42.13c-6.56-16-13.1-30.57-15.33-30.66a11,11,0,0,0-2.8.59c-12.41,3.63-57.63,22.38-69.14,10.67-12.76-13,5.69-44.24,5.69-44.24s30.69-4.38,33,2.55a48.61,48.61,0,0,1,1.3,6.22c.35,2.12.59,3.9.59,3.9h0c.95-.24,31.76-8.19,43.9,0C205,292.39,218.66,377.82,218.66,377.82Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.4,389.55a9.21,9.21,0,0,0-3.18-.81h0s-3.8-2.23-7.56-10.92l-4.23,0a3.51,3.51,0,0,0-3.26,2.33,2,2,0,0,0-.12.59,26.08,26.08,0,0,0,.33,3,84.57,84.57,0,0,0,2.47,10l.72-.18-1.3-6.31c-.44-2.15,1.82-.08,2.86,2.09s2.65,4.34,7.33,3.27C228.91,391.32,231.1,390.53,229.4,389.55Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.89,375.55s5.29,11.06,8.33,13.19c0,0-4.08,2.44-8.33-3-5.49-7-6.84-5-6.84-5a19.94,19.94,0,0,1,.67-3.57C212.54,374.89,217.89,375.55,217.89,375.55Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.17,415.9a9,9,0,0,0-2.89-1.53h0s-3.16-3.07-4.75-12.4l-4.11-1a3.48,3.48,0,0,0-3.71,1.49,2.24,2.24,0,0,0-.26.54,23.88,23.88,0,0,0-.41,3,84.06,84.06,0,0,0,.05,10.26h.74l.23-6.45c.09-2.19,1.78.36,2.29,2.71s1.54,4.85,6.34,4.92C170.28,417.5,172.6,417.26,171.17,415.9Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.32,399.57s2.51,12,5,14.8c0,0-4.54,1.39-7.38-4.87-3.68-8.11-5.45-6.53-5.45-6.53a20.35,20.35,0,0,1,1.49-3.31C158.28,397.66,163.32,399.57,163.32,399.57Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.32,399.57s2.51,12,5,14.8c0,0-4.54,1.39-7.38-4.87-3.68-8.11-5.45-6.53-5.45-6.53a20.35,20.35,0,0,1,1.49-3.31C158.28,397.66,163.32,399.57,163.32,399.57Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.44,335c-6.56-16-13.1-30.57-15.33-30.66a11,11,0,0,0-2.8.59l.09-3.65a23.23,23.23,0,0,1,14.92,7.15C196.61,313.1,196.17,326.74,195.44,335Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.21,318.74s34.78-3.65,38.41-.51c3.8,3.29-5.38,9.93-11.68,81.43l6.59,2.31s26.14-77.18,25.89-87.43-12-13.25-12-13.25S154.49,314.54,130.21,318.74Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.42,314.54c.25,10.25-25.89,87.43-25.89,87.43l-6.59-2.31c6.3-71.5,15.48-78.14,11.68-81.43-.82-.71-3.27-1.07-6.55-1.2a201.35,201.35,0,0,0-21.23.77c-6,.46-10.63.94-10.63.94,3.07-.53,6.12-1.21,9.11-2A173,173,0,0,0,177.4,301.3h0S189.17,304.29,189.42,314.54Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.4,301.3c-.48.41-10.15,8.68-15.33,15.73a201.35,201.35,0,0,0-21.23.77l-1.52-1.05A173,173,0,0,0,177.4,301.3Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,280.51l-16.7,46.2s-40.23-1-48.14-9.09-5.14-21.57,1-31.06,37-11.27,37-11.27l6.57,8.29S161.82,280.51,171,280.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,280.51l-16.7,46.2s-40.23-1-48.14-9.09-5.14-21.57,1-31.06,37-11.27,37-11.27L148,280.2l2.52,3.18.16.2S161.82,280.51,171,280.51Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.52,283.38l-19.72,4.41s9.78-5.4,17.2-7.59Z",
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.86,273.93l3.82,9.65-9.29,2-4.93-5.14-11,10.73-25.05,1.2,13.4-21L112.61,255l-1.39-18.29-1.16-15.26s12.66-5.15,23.24-4.6,19,1.9,19,1.9C158.87,234.54,146.86,273.93,146.86,273.93Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.86,273.93l3.82,9.65-9.29,2-4.93-5.14-11,10.73-25.05,1.2,13.4-21L112.61,255l-1.39-18.29-1.16-15.26s12.66-5.15,23.24-4.6,19,1.9,19,1.9C158.87,234.54,146.86,273.93,146.86,273.93Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.16,216.18a.81.81,0,0,1-.47,1.14l-8.63,3a1.06,1.06,0,0,1-1.28-.53L65.9,203.45a.91.91,0,0,1,.44-1.25l8.63-3a1.19,1.19,0,0,1,1.32.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.29,200.05l8,16.51a.69.69,0,0,1-.4,1.05l-7.31,2.56c-.49.17-1.49.21-1.71-.25l-8-16.57c-.22-.47.48-1.15,1-1.32l7.31-2.56A.94.94,0,0,1,75.29,200.05Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7,234.74l-5.83-11.67S80,214,78.74,212.72s-2.67-5.75-5-6.11S68.35,217.08,68.35,218s2.18,6.43,2.18,6.43l5.14,16Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.2,210l-4.35,4.75-3.37-4.35s-.59,1.48-1.5,1.56-6.51,3-7.52,1.87a5.72,5.72,0,0,1-.83-2,40.56,40.56,0,0,1-.87-4.59s9.44-5.44,10.53-4.59c.12.09.3.25.53.45C157.76,204.82,163.2,210,163.2,210Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.82,203.1c-.61,3-2.76,7.55-10.19,8.73a40.56,40.56,0,0,1-.87-4.59s9.44-5.44,10.53-4.59C155.41,202.74,155.59,202.9,155.82,203.1Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.69,238.89c-3,6.72-14.38,4.28-22.2,1.63a80.68,80.68,0,0,1-7.75-3.08l.19-6.11.39-12.61,8.94,5.73,6.33,4.06L156,212l5.5-5.36S186.44,228.35,181.69,238.89Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.69,238.89c-3,6.72-14.38,4.28-22.2,1.63a80.68,80.68,0,0,1-7.75-3.08l.19-6.11.39-12.61,8.94,5.73,6.33,4.06L156,212l5.5-5.36S186.44,228.35,181.69,238.89Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.49,240.52a80.68,80.68,0,0,1-7.75-3.08l.19-6.11,2-4.75S158.26,233.47,159.49,240.52Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,234.74s-8.75-2.92-9.71-10.29l6.33,4.06Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.7,
    y: 242.27,
    width: 5.52,
    height: 9.02,
    rx: 0.79,
    transform: "translate(254.93 493.57) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.41,
    y: 242.87,
    width: 4.48,
    height: 6.13,
    transform: "translate(255.31 491.86) rotate(180)",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.06,
    y: 240.1,
    width: 0.99,
    height: 3.61,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.61,255l-1.39-18.29,3-2.74S117.51,244.86,112.61,255Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.54,221.42s11.71,27.65,12.58,37.79c0,0,7.71-24.1,6.79-36Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.41,222.67s3.12-10.88,15-9.89,16.45,12.14,16.45,12.14l-5.56-2.84L137,240.45l-11.48-18.18Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.41,222.67s3.12-10.88,15-9.89,16.45,12.14,16.45,12.14l-5.56-2.84L137,240.45l-11.48-18.18Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.24,181.79s-.56-5-7.15-5.35-12.13,4.28-8.18,12.23,4.08,16.85-1.32,17.94c0,0,10.6,4.91,12.53-11.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,179.5s-6.15-7.53-18,1-2.56,26.5,6.69,26S145,179.5,145,179.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.12,215.23a9.54,9.54,0,0,0,.94,3.72l-4.86,14-11.52-15.28c4.11-.53,6.51-5.6,7.74-9.37a31.75,31.75,0,0,0,1-4l0-.13.26.15,9.28,5.23A6.27,6.27,0,0,0,140.12,215.23Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,209.55a6.27,6.27,0,0,0-2.91,5.68,12,12,0,0,1-7.7-6.93,31.75,31.75,0,0,0,1-4l.29,0Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.53,179.19s7-6,15.08-2,8,16.07,2.57,20.19S134.53,179.19,134.53,179.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.47,181.7c8.48-.84,11.66,3.43,13.15,12.11,1.86,10.84.21,18.85-10.63,17.56C127.27,209.64,125.38,183.1,139.47,181.7Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.09,193.88a17.82,17.82,0,0,0,2.81,3.27,2.33,2.33,0,0,1-2.14,1.18Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.83,193.7c.08.69-.23,1.3-.69,1.36s-.91-.46-1-1.16.22-1.3.68-1.36S141.74,193,141.83,193.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.64,192.6l1.44-.78S141.49,193.19,140.64,192.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.45,192.49c.09.7-.22,1.31-.68,1.36s-.91-.46-1-1.15.22-1.31.69-1.36S150.36,191.8,150.45,192.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.27,191.39l1.44-.78S150.11,192,149.27,191.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.16,187.85a4.45,4.45,0,0,0-3.55,1.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.7246800000000001px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.29,186.88a4,4,0,0,1,3.45.36",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.7246800000000001px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.61,196.91s3.28-7.36,2.14-12.68c0,0,16.13-8.53,18.65,8.45,0,0,.14-15.32-14.47-14.21s-12.44,22.44-4.28,28.05C133.65,206.52,129.59,201.52,131.61,196.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.18,198.57a3.76,3.76,0,0,0-4.35-3c-2.6.55-3.32,6.07,3.35,6.72C133.14,202.38,133.58,201.41,133.18,198.57Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.87,201.65a20.91,20.91,0,0,0-.8,3l-.55,0c-2.49-.08-3.62-.94-4.11-1.88a3.16,3.16,0,0,1-.35-1.48,3,3,0,0,1,.1-.86,11.91,11.91,0,0,0,4.86,1.18C148.54,201.65,148.87,201.65,148.87,201.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,201.61l-.26.88c-2.35-.09-4-.46-4.7-1.2a3,3,0,0,1,.1-.86A11.91,11.91,0,0,0,148,201.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.52,204.65c-2.49-.08-3.62-.94-4.11-1.88a8.27,8.27,0,0,1,2.74.65A3,3,0,0,1,147.52,204.65Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.36,189.71s-1.87-.68-5.34.55v0a3.94,3.94,0,0,0-3.1.35,17.5,17.5,0,0,0-6.37,1.23l-6.63,2.52v.72l6.76-1.74c.56,1.66,2.07,4.2,4.35,3.73,3-.62,2.85-3.76,2.62-5.23.64-.74,1.85-.85,2.09-.28.25,1.3,1.08,4.3,4.26,4.12S153.36,189.71,153.36,189.71Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.36,189.71s-1.87-.68-5.34.55v0a3.94,3.94,0,0,0-3.1.35,17.5,17.5,0,0,0-6.37,1.23l-6.63,2.52v.72l6.76-1.74c.56,1.66,2.07,4.2,4.35,3.73,3-.62,2.85-3.76,2.62-5.23.64-.74,1.85-.85,2.09-.28.25,1.3,1.08,4.3,4.26,4.12S153.36,189.71,153.36,189.71Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.22,190.13l-1.33,4.93s1.88.64,2.38-.87a9.23,9.23,0,0,0-.13-4.06A2.61,2.61,0,0,0,152.22,190.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.79,190.09l-1.33,5s-.84-.26-.85-.58l1.1-4.25S151.48,190.12,151.79,190.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.74,191.35l-1.33,4.93s1.88.63,2.39-.88a9.28,9.28,0,0,0-.14-4.05A2.61,2.61,0,0,0,143.74,191.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.31,191.3l-1.32,5s-.85-.26-.86-.58l1.1-4.25S143,191.33,143.31,191.3Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M139.17,181.37s2,9.43-4.64,13.46",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.35,182.36s-2,14.29-10.84,15-.46-15.24,3-18.33C133.11,177.61,138.68,175.66,139.35,182.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.06,221.42c-3.8.53-15.93,25.19-18.83,25.2s-12-19.19-12-19.19L71.71,233s9,30.78,19.18,29.34c11-1.56,23-19.53,23-19.53a52.16,52.16,0,0,0,0-11.85A22.14,22.14,0,0,0,110.06,221.42Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.06,221.42c-3.8.53-15.93,25.19-18.83,25.2s-12-19.19-12-19.19L71.71,233s9,30.78,19.18,29.34c11-1.56,23-19.53,23-19.53a52.16,52.16,0,0,0,0-11.85A22.14,22.14,0,0,0,110.06,221.42Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.69,
    y: 211.64,
    width: 20.84,
    height: 32.72,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.69,
    y: 211.64,
    width: 20.84,
    height: 32.72,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.14,
    y: 211.64,
    width: 20.84,
    height: 32.72,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.14,
    y: 211.64,
    width: 20.84,
    height: 32.72,
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.11 213.38 267.11 256.89 238.23 256.89 238.23 224.47 253.22 213.38 267.11 213.38",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.34,
    y: 213.38,
    width: 8.77,
    height: 43.51,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.68,
    y: 220.21,
    width: 6.53,
    height: 3.05,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.68,
    y: 225.21,
    width: 6.53,
    height: 9.87,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.68,
    y: 237.76,
    width: 6.53,
    height: 2.56,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.69,
    y: 210.64,
    width: 20.84,
    height: 32.72,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.69,
    y: 210.64,
    width: 20.84,
    height: 32.72,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.14,
    y: 210.64,
    width: 20.84,
    height: 32.72,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.14,
    y: 210.64,
    width: 20.84,
    height: 32.72,
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.11 213.38 252.11 256.89 223.23 256.89 223.23 224.47 238.22 213.38 252.11 213.38",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.34,
    y: 213.38,
    width: 8.77,
    height: 43.51,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.68,
    y: 220.21,
    width: 6.53,
    height: 3.05,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.68,
    y: 225.21,
    width: 6.53,
    height: 9.87,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.68,
    y: 237.76,
    width: 6.53,
    height: 2.56,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.93 417.45 210.05 417.45 211.06 264.21 202.93 264.21 203.93 417.45",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.92 264.45 203.08 289.18 203.92 417.45 210.05 417.45 210.89 289.18 211.05 264.45 202.92 264.45",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.92 264.45 203.08 289.45 210.89 289.45 211.05 264.45 202.92 264.45",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.89 417.45 145.01 417.45 156.02 264.21 147.89 264.21 138.89 417.45",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.88 417.45 145.01 417.45 155.48 271.82 156.02 264.45 147.89 264.45 147.45 271.82 138.88 417.45",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.45 271.45 155.48 271.45 156.02 264.45 147.89 264.45 147.45 271.45",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.97 417.45 277.1 417.45 268.09 264.21 259.96 264.21 270.97 417.45",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.96 264.45 260.5 271.82 270.97 417.45 277.09 417.45 268.53 271.82 268.09 264.45 259.96 264.45",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.09 264.45 259.96 264.45 260.5 271.45 268.53 271.45 268.09 264.45",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.61,260.37H272.37a2.16,2.16,0,0,1,2.16,2.16V268a0,0,0,0,1,0,0H141.45a0,0,0,0,1,0,0v-5.51A2.16,2.16,0,0,1,143.61,260.37Z",
    transform: "translate(415.98 528.42) rotate(180)",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.61,260.37H272.37a2.16,2.16,0,0,1,2.16,2.16V268a0,0,0,0,1,0,0H141.45a0,0,0,0,1,0,0v-5.51A2.16,2.16,0,0,1,143.61,260.37Z",
    transform: "translate(415.98 528.42) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.45,
    y: 260.37,
    width: 133.08,
    height: 3.84,
    transform: "translate(415.98 524.58) rotate(180)",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.65,261.37H278.33a2.16,2.16,0,0,0,2.16-2.16h0a2.16,2.16,0,0,0-2.16-2.16H137.65a2.16,2.16,0,0,0-2.16,2.16h0A2.16,2.16,0,0,0,137.65,261.37Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.65,261.37H278.33a2.16,2.16,0,0,0,2.16-2.16h0a2.16,2.16,0,0,0-2.16-2.16H137.65a2.16,2.16,0,0,0-2.16,2.16h0A2.16,2.16,0,0,0,137.65,261.37Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.49,253v2.65c0,.79-1.36,1.35-2.15,1.35H172.55c-.79,0-2.06-.56-2.06-1.35V253Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.49,253v2.65c0,.79-1.36,1.35-2.15,1.35H172.55c-.79,0-2.06-.56-2.06-1.35V253Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.49,253v2.65c0,.79-1.36,1.35-2.15,1.35H193.59c-.8,0-2.1-.56-2.1-1.35V253Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.4,220.46,239,253.94a2.59,2.59,0,0,1-2.38,2H196.47a1.75,1.75,0,0,1-1.51-2.24l7.35-33.12A2.3,2.3,0,0,1,204.7,219h40.18C246,219,246.64,219.38,246.4,220.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.4,220.46,239,253.94a2.59,2.59,0,0,1-2.38,2H196.47a1.75,1.75,0,0,1-1.51-2.24l7.35-33.12A2.3,2.3,0,0,1,204.7,219h40.18C246,219,246.64,219.38,246.4,220.46Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.4,220.46,239,253.94a2.59,2.59,0,0,1-2.38,2H197.84a1.75,1.75,0,0,1-1.52-2.24l7.36-33.12a2.3,2.3,0,0,1,2.39-1.64h38.81C246,219,246.64,219.38,246.4,220.46Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.76,241.92c1.87,0,3.79-2,4.28-4.48s-.64-4.49-2.52-4.49a2.91,2.91,0,0,0-1,.2,5.74,5.74,0,0,1-3.19,4.09,1.46,1.46,0,0,0,0,.2C219.75,239.91,220.88,241.92,222.76,241.92Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.33,324.27h0a2,2,0,0,1-2-2c.42-22.82,7.88-37.69,10.8-42.66A2,2,0,0,1,112,279l1.56,1.09-1.64-1.15.09.06a2,2,0,0,1,.6,2.64c-2.64,4.56-9.85,18.95-10.27,40.68A2,2,0,0,1,100.33,324.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.33,324.27h0a2,2,0,0,1-2-2c.42-22.82,7.88-37.69,10.8-42.66A2,2,0,0,1,112,279l1.56,1.09-1.64-1.15.09.06a2,2,0,0,1,.6,2.64c-2.64,4.56-9.85,18.95-10.27,40.68A2,2,0,0,1,100.33,324.27Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M125.76,282.08H70.37a3.29,3.29,0,0,1-3.29-3.3h0a3.29,3.29,0,0,1,3.29-3.3h55.39a3.29,3.29,0,0,1,3.29,3.3h0A3.29,3.29,0,0,1,125.76,282.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.76,282.08H70.37a3.29,3.29,0,0,1-3.29-3.3h0a3.29,3.29,0,0,1,3.29-3.3h55.39a3.29,3.29,0,0,1,3.29,3.3h0A3.29,3.29,0,0,1,125.76,282.08Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlotBookingConfirmation);
export default __webpack_public_path__ + "static/media/slot-booking-confirmation.dd00756968b65d86ab2b48e1c6279117.svg";
export { ForwardRef as ReactComponent };